module.exports = __webpack_public_path__ + "static/img/14.a3fac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14.jpg
// module id = 285
// module chunks = 0